'use client';

import { useEffect, useState } from 'react';

export default function useGeolocation() {
  const [coords, setCoords] = useState({
    latitude: 0,
    longitude: 0,
  });

  const isCoordsEmpty = coords.latitude === 0 && coords.longitude === 0;

  useEffect(() => {
    if (window && window.navigator && window.navigator.geolocation) {
      window.navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setCoords({
            latitude,
            longitude,
          });
        },
        (error) => {
          console.error('Error getting geolocation:', error);
          setCoords({
            latitude: 0,
            longitude: 0,
          });
        },
      );
    }
  }, []);

  return { coords, isCoordsEmpty };
}
